import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { Icon } from 'core/ui/atoms';

const Accordion = ({ to, subMenus, content, children, subMenuIcon = 'default', ...props }) => {
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);

  const toggleSubMenu = (e) => {
    e.stopPropagation();
    setIsSubMenuOpen((prevState) => !prevState);
  };

  const Comp = to ? CustomLink : Anchor;

  const RenderSubMenuIcon = () => {
    if (subMenuIcon === 'default') {
      return isSubMenuOpen ? <CustomIcon icon='minus' /> : <CustomIcon icon='plus' />;
    }
    return isSubMenuOpen ? <CustomIcon icon='caret_down' /> : <CustomIcon icon='caret_down' />;
  };

  return (
    <div>
      <MainItemContainer $subMenuIcon={subMenuIcon === 'default'}>
        <MainItem $subMenuIcon={subMenuIcon === 'default'} {...(subMenus && { onClick: toggleSubMenu })}>
          <Comp {...props}>{children}</Comp>
          <RenderSubMenuIcon />
        </MainItem>
        {subMenus && subMenus.length > 0 && isSubMenuOpen && (
          <SubMenu>
            {subMenus.map((submenu, index) => (
              <SubMenuItem key={index}>
                &#8226; {submenu.label}
              </SubMenuItem>
            ))}
          </SubMenu>
        )}
        {content && isSubMenuOpen && (
          <SubMenu>
            {content}
          </SubMenu>
        )}
      </MainItemContainer>
    </div>
  );
};

Accordion.propTypes = {
  to: PropTypes.string,
  subMenus: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
    }),
  ),
  content: PropTypes.object,
  children: PropTypes.node,
  subMenuIcon: PropTypes.string,
};

const CustomLink = styled(NavLink)`
  font-size: 22px;
  font-family: ${(p) => p.theme.typography.familyLarken};
  color: ${(p) => p.theme.colors.primaryV2};
`;

const Anchor = styled.a`
  font-size: 22px;
  font-family: ${(p) => p.theme.typography.familyLarken};
  color: ${(p) => p.theme.colors.primaryV2};
  margin-bottom: 24px;
`;

const MainItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: ${({ $subMenuIcon }) => $subMenuIcon ? '1px solid #C9D5C8' : 'none'};
`;

const MainItem = styled.div`
  display: flex;
  justify-content: ${({ $subMenuIcon }) => $subMenuIcon ? 'space-between' : 'unset'};
  cursor: pointer;
  font-size: ${(p) => p.theme.typography.sizes.h1};
  color: ${(p) => p.theme.colors.primaryV2};
`;

const SubMenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 1.5em;
`;

const CustomIcon = styled(Icon)`
  margin-top: 10px;
  font-size: 0.425em;
  color: ${(p) => p.theme.colors.primaryV2};
`;

const SubMenuItem = styled.a`
  display: block;
  text-decoration: none;
  font-family: ${(p) => p.theme.typography.familyPoppins} !important;
  padding: 0.1em 0.5em !important;
  font-size: ${(p) => p.theme.typography.sizes.small} !important;
  color: ${(p) => p.theme.colors.primaryV2};
`;

export default Accordion;
